// extracted by mini-css-extract-plugin
export default {"alignmentTool":"AlignmentToolStyles-modules__alignmentTool__ATELx"};